export function setupAuthInterceptor(onSentryReport) {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
        try {
            const response = await originalFetch(...args);

            if (onSentryReport) {
                try {
                    const clonedForSentry = response.clone();
                    clonedForSentry.json().then(data => {
                        if (data?.eventId) {
                            onSentryReport(data.eventId);
                        }
                    }).catch(() => {});
                } catch (e) {}
            }

            if (response.status === 401) {
                const url = typeof args[0] === 'string' ? args[0] : args[0].url;

                if (url.includes('/api/users/refresh')) {
                    localStorage.removeItem('user');
                    window.location.replace('/user/login');
                    return response;
                }

                try {
                    const refreshResp = await originalFetch('/api/users/refresh', {
                        method: 'POST',
                        credentials: 'include',
                        headers: { 'Content-Type': 'application/json' }
                    });

                    if (refreshResp.ok) {
                        return await originalFetch(...args);
                    } else {
                        localStorage.removeItem('user');
                        window.location.replace('/user/login');
                        return response;
                    }
                } catch (refreshErr) {
                    localStorage.removeItem('user');
                    window.location.replace('/user/login');
                    return response;
                }
            }

            if (response.status === 403) {
                const userStr = localStorage.getItem('user');
                if (userStr) {
                    try {
                        const user = JSON.parse(userStr);
                        const homePath = user.admin ? "/admin" : (user.instructor ? "/instructor" : "/learn");
                        window.location.replace(homePath);
                    } catch (e) {
                        window.location.replace('/user/login');
                    }
                } else {
                    window.location.replace('/user/login');
                }
            }

            return response;

        } catch (error) {
            if (error.name === 'AbortError') {
                throw error;
            }
            throw error;
        }
    };
}